import React, { Fragment } from 'react'
import '@loyal_template/placeholder.css'

import imagefallback from '@loyal_images/products/product_placeholder.png'

const Placeholder = () => (
  <Fragment>
    <div className='col-12 px-1 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-3 txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12 px-0 txt-center'>
              <img src={imagefallback} className='img-w-auto' />
            </div>
          </div>
        </div>
        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row shimmer'>
                <div className='col py-half px-0'>
                  <p className={`col-6 py-half bg-ui-3 radius`} />
                  <h2 className='col-10 py-half bg-ui-2 radius mt-1' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul className='tracking-steps col-12 px-0 pt-2'>
      <li className='pos-relative'>
        <div className='row shimmer'>
          <div className='col-auto'>
            <div className='row mx-0'>
              <div className='col-auto py-2 px-2 bg-ui-3 radius-circle' />
            </div>
          </div>
          <div className='col'>
            <div className='row mx-0 shimmer'>
              <div className='col-10 py-half bg-ui-3 radius' />
              <div className='col-12 mt-1 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
      </li>
      <li className='pos-relative'>
        <div className='row shimmer'>
          <div className='col-auto'>
            <div className='row mx-0'>
              <div className='col-auto py-2 px-2 bg-ui-3 radius-circle' />
            </div>
          </div>
          <div className='col'>
            <div className='row mx-0 shimmer'>
              <div className='col-10 py-half bg-ui-3 radius' />
              <div className='col-8 mt-1 py-half bg-ui-4 radius' />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </Fragment>
)

export default Placeholder



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Placeholder.js